module.exports = __webpack_public_path__ + "static/img/amamos.35cdbb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/amamos.png
// module id = 0p7L
// module chunks = 0